// extracted by mini-css-extract-plugin
export default {"container":"Iz-z","modal":"Jz-z","dimensions":"Kz-z","brandName":"Lz-z","productName":"Mz-z","labelValue":"Nz-z","recipientEmail":"Oz-z","recommendedFit":"Pz-z","hiddenField":"Qz-z"};